import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useCreateAudit } from './create-audit-transaction.controller';

const ID = 'create-audit-transaction';

export const CreateAuditTransaction = () => {
    const viewProps = useCreateAudit();

    return (
        <WizardScreenContainer
            id={ID}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.DEFAULT,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}>
            <div className='flex size-full flex-col items-center justify-center gap-4'>
                <Spinner className='text-border-default fill-brand-primary size-12' />
                <div className='text-always-black text-center text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.create-audit-transaction.working'
                        description='Primary message on the create audit transaction screen while the transaction is being set up'
                        defaultMessage='One moment…'
                    />
                </div>
                <div className='text-foreground-default text-center text-base'>
                    <FormattedMessage
                        id='kiosk.wizard.create-audit-transaction.please-wait'
                        description='Secondary message on the create audit transaction screen asking the user to wait'
                        defaultMessage='Please wait while we get things ready.'
                    />
                </div>
            </div>
        </WizardScreenContainer>
    );
};
